export default __webpack_public_path__ + "static/media/blogDetail5.0b2e7aef.png";